import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  postWrapper: {
    borderRadius: 4,
    ...theme.mixins.appContainer,
    ...theme.mixins.appContainersSpacing,
  },
  postWrapperShadow: {
    // boxShadow: `0 1px 3px rgba(0, 0, 0, 0.1)`,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  userInfo: {
    display: 'flex',
    marginLeft: 8,
    flex: 1,
    flexDirection: 'column',
  },
  createdAt: {
    color: theme.palette.grey[600],
  },

  content: {
    marginTop: 8,
  },
  editedPostContent: {},
  editedPostBottom: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8,
  },
  uploadFileButton: {
    height: 32,
    lineHeight: '24px',
    padding: '4px 8px',
    display: 'inline-flex',
    marginBottom: 4,
    '& svg': {
      marginRight: 8,
    },
  },
  filesWrapper: {
    marginTop: 8,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,

    '&>div:first-of-type': {
      alignItems: 'center',
      display: 'flex',
    },
  },
  repliedPostWrapper: {
    borderLeft: `${theme.palette.primary.main} 2px solid`,
    marginLeft: theme.spacing(1),

    '& > div': {
      padding: `${theme.spacing(1)} !important`,
      backgroundColor: 'transparent !important',
      boxShadow: 'none !important',
    },
  },
  commentsWrapper: {
    marginTop: '8px',
    paddingTop: '8px',
  },
  commentsWrapperBorder: {
    borderTop: `1px solid ${theme.palette.grey[200]}`,
  },
  newCommentWrapper: {
    width: '100%',
    marginTop: 8,
    '& > div + div': {
      marginTop: theme.spacing(1),
    },
    '& > div:first-of-type': {
      marginTop: 0,
    },
  },
  answeredCommentWrapper: {
    borderLeft: `${theme.palette.primary.main} 2px solid`,
    marginLeft: 32,
  },

  uploadedFilesWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  newCommentData: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
  },

  menuItem: {
    '& svg': {
      marginRight: 8,
    },
  },
  delete: {
    color: theme.palette.red[300],
  },
  postContent: {
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
  },
}));
